/* eslint-disable react-refresh/only-export-components */
import { createFileRoute, redirect } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/customer/campaigns/$id/analytics')({
  beforeLoad: (ctx) => {
    requireRole(['customer'])()
    throw redirect({
      to: '/customer/reports',
      search: { campaign_id: ctx.params.id },
    })
  },
})
